module.exports = __webpack_public_path__ + "static/media/pic2-man.abe22fa3.png";